module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-210.fd1415ab.svg";